import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

function RandomMode() {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: "center" }}>
      <h1 className="main-title">Random Mode</h1>
      <br /><br /><br />

      <p style={{ marginTop: "40px", fontSize: "1.2rem" }}>
        This is the Random Mode page. Add your features here!
      </p>
    </div>
  );
}

export default RandomMode;
